import { AccountUserType } from '__generated__/atlas-types'

import { fromGlobalId } from 'utils/transformations/graphql'
import { CurrentUserInfo } from 'utils/userInfo'

export const isRestrictedNoAccessViewer = (
  userInfo: Pick<CurrentUserInfo, 'loggedAsAdmin' | 'accountUserType'>,
): boolean =>
  !userInfo.loggedAsAdmin &&
  userInfo.accountUserType === AccountUserType.NO_ACCESS

const numericIdFromGlobalId = (globalId: string): number | null => {
  try {
    const { id } = fromGlobalId(globalId)
    if (!id) {
      return null
    }
    const numericId = parseInt(id, 10)
    return Number.isNaN(numericId) ? null : numericId
  } catch {
    return null
  }
}

export const hasOtherUsableAccounts = (
  userInfo: Pick<CurrentUserInfo, 'account' | 'accounts'>,
): boolean => {
  const currentAccountId = userInfo.account?.accountId
  return (userInfo.accounts ?? []).some((account) => {
    const accountId = numericIdFromGlobalId(account.id)
    if (accountId == null) {
      return false
    }
    return accountId !== currentAccountId
  })
}
